const { REACT_APP_HOST } = process.env;

export const FILE_URL = `${REACT_APP_HOST}file/upload`;
export const GET_FILE_URL = `${REACT_APP_HOST}file/upload/url`;
export const POST_PUBLIC_FILE_URL = `${REACT_APP_HOST}file/public`;
export const POST_PRIVATE_FILE_URL = `${REACT_APP_HOST}file/private`;
export const PING_URL = `${REACT_APP_HOST}ping`;
